import { track } from './index'
import { Events } from './constants'

const observerMap = new WeakMap()

export const vTrack = {
  mounted(el, binding) {
    try {
      const arg = binding.arg
      const value = binding.value
      const eventName = typeof value === 'string' ? value : value?.event
      const extraParams = typeof value === 'object' && value !== null ? (value.params || {}) : {}

      if (arg === 'click') {
        const handler = () => {
          try {
            track(Events.BTN_CLICK, {
              element_id: eventName,
              element_text: (el.textContent || '').trim().slice(0, 50),
              ...extraParams,
            }, 'semi')
          } catch { /* 静默 */ }
        }
        el.__trackClickHandler = handler
        el.addEventListener('click', handler, { passive: true })
      }

      if (arg === 'exposure') {
        const observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              try {
                track(Events.ELEMENT_EXPOSURE, {
                  element_id: eventName,
                  ...extraParams,
                }, 'semi')
              } catch { /* 静默 */ }
              observer.unobserve(el)
            }
          }
        }, { threshold: 0.5 })
        observer.observe(el)
        observerMap.set(el, observer)
      }
    } catch { /* 静默 */ }
  },

  unmounted(el, binding) {
    try {
      if (binding.arg === 'click' && el.__trackClickHandler) {
        el.removeEventListener('click', el.__trackClickHandler)
        delete el.__trackClickHandler
      }
      if (binding.arg === 'exposure') {
        const observer = observerMap.get(el)
        if (observer) {
          observer.disconnect()
          observerMap.delete(el)
        }
      }
    } catch { /* 静默 */ }
  },
}
